"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _videoPlayerHelper = require("./videoPlayerHelper");
Object.keys(_videoPlayerHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _videoPlayerHelper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _videoPlayerHelper[key];
    }
  });
});